import api from 'services/financial/payable'

export const handleSave = async (values: any) => {
  let res = await api.create(values)

  return res?.data?.success
}
